import { OverlayTrigger, Tooltip, type OverlayTriggerProps } from 'react-bootstrap'

interface TooltipTriggerProps extends Omit<OverlayTriggerProps, 'overlay'> {
    tooltipText: string;
};

export default function TooltipTrigger({
    children,
    tooltipText,
    delay,
    placement = "bottom",
    ...rest
}: TooltipTriggerProps) {
    return (
        <OverlayTrigger
            delay={delay || { show: 250, hide: 350 }}
            overlay={<Tooltip>{tooltipText}</Tooltip>}
            placement={placement}
            {...rest}
        >
            {children}
        </OverlayTrigger>
    )
};